"use client";

import { useSyncExternalStore } from "react";
import {
  subscribeFocus,
  getFocusSnapshot,
  getFocusServerSnapshot,
  getRemainingMs,
  getElapsedMs,
  type FocusState,
  type FocusMode,
} from "@/lib/focus-timer-store";

/** Subskrybuje moduł-store timera skupienia (przeżywa nawigację i remont). */
export function useFocusState(): FocusState {
  return useSyncExternalStore(subscribeFocus, getFocusSnapshot, getFocusServerSnapshot);
}

/**
 * Zwraca sam tryb (idle|focus|break) jako prymityw — komponent re-renderuje się
 * TYLKO przy zmianie trybu, nie co sekundę (getSnapshot zwraca string, Object.is).
 * Bezpieczne do użycia w dużych komponentach (PanelShell, kontroler motywu).
 */
export function useFocusMode(): FocusMode {
  return useSyncExternalStore(
    subscribeFocus,
    () => getFocusSnapshot().mode,
    () => "idle" as FocusMode
  );
}

export { getRemainingMs, getElapsedMs };

/** „MM:SS" (albo „H:MM:SS" powyżej godziny). */
export function formatClock(ms: number): string {
  const total = Math.max(0, Math.ceil(ms / 1000));
  const h = Math.floor(total / 3600);
  const m = Math.floor((total % 3600) / 60);
  const s = total % 60;
  const mm = String(m).padStart(2, "0");
  const ss = String(s).padStart(2, "0");
  return h > 0 ? `${h}:${mm}:${ss}` : `${mm}:${ss}`;
}
